function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import "jquery";
/**
 * メッセージ
 */

var SphereCastMessageSmartphone = /*#__PURE__*/function () {
  /**
   * 初期化を行います。
   *
   * @param common 共通
   */
  function SphereCastMessageSmartphone(common) {
    _classCallCheck(this, SphereCastMessageSmartphone);

    this.common = common;
  }
  /**
   * HTMLの構造が組み立てられた後すぐに実施する処理
   */


  _createClass(SphereCastMessageSmartphone, [{
    key: "ready",
    value: function ready() {
      this.common.ready();
      this.common.bind();
    }
  }]);

  return SphereCastMessageSmartphone;
}();

export { SphereCastMessageSmartphone as default };